const apiUrl = process.env.VUE_APP_API_URL;

module.exports = {
  apiUrl,
  // Legacy aliases — both now point to customer-service-api
  csbpApi: apiUrl,
  sweepsApi: apiUrl,
  environment: process.env.NODE_ENV,
};
